const animation = require("./tickCard.json");

module.exports = {
    loop: false,
    autoplay: false,
    animationData: animation,
    rendererSettings: {
        preserveAspectRatio: 'none'
    },
}